import { trackEvent } from '@patrianna/analytics'

import BannerTile from 'components/BannerTile'
import ROUTES from 'config/routes.json'
import { ImagesDirectory, generateImageUrl } from 'src/utils/setImageUrl'

export default function Promotions() {
  const bannerUrl = generateImageUrl('banners/promotions-image/source.png', ImagesDirectory.BANNERS)
  const onClickHandler = () => {
    trackEvent('clicked_on_banner', { category: 'promotions-banner' })
  }

  return (
    <BannerTile
      url={ROUTES.PROMOTIONS}
      onClick={onClickHandler}
      src={bannerUrl}
      alt='Promotions'
      dataTest='promotions-banner'
    />
  )
}
